// libs
import React, { memo } from 'react';

// constants
import { ROLES, TAB_INDEX } from 'shared/constants';

// components
import OverlaySheet, {
  SHEET_TRANSITION,
  OverlaySheetContext,
} from 'shared/components/OverlaySheet';

// styles
import {
  FixedContent,
  ContentWrapper,
  CloseButton,
  MwebIFrame,
  DwebIFrame,
  DwebOverlaySheet,
} from './styles';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';
import { BREAKPOINTS } from 'shared/styles/base';

// constants
import { SOLD_BY_NYKAA_FASHION } from 'shared/constants/uri';

// icons
import CloseIcon from '@nykaa/ui-components/Icons/close';

interface IPDPModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
}

const TITLE = 'Sold By Nykaa Fashion';

const Modal = ({ isOpen, onClose }: IPDPModalProps) => {
  const { deviceWidth } = useResponsiveContext();
  const isMobile = deviceWidth < BREAKPOINTS.DESKTOP;

  if (isOpen === false) {
    return null;
  }

  if (isMobile) {
    return (
      <OverlaySheet
        onHide={() => onClose()}
        navKey="fitcode"
        transitionFrom={SHEET_TRANSITION.BOTTOM}
      >
        <OverlaySheetContext.Consumer>
          {({ doHide }) => (
            <FixedContent>
              <ContentWrapper>
                <CloseButton
                  role={ROLES.BUTTON}
                  tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
                  className="close-btn"
                  onKeyDown={() => doHide()}
                  onClick={() => doHide()}
                >
                  <CloseIcon />
                </CloseButton>
                <MwebIFrame title={TITLE} src={SOLD_BY_NYKAA_FASHION} />
              </ContentWrapper>
            </FixedContent>
          )}
        </OverlaySheetContext.Consumer>
      </OverlaySheet>
    );
  }

  return (
    <DwebOverlaySheet
      onHide={() => onClose()}
      navKey="fitcode"
      transitionFrom={SHEET_TRANSITION.RIGHT}
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <>
            <CloseButton
              role={ROLES.BUTTON}
              tabIndex={0}
              className="close-btn"
              onKeyDown={() => doHide()}
              onClick={() => doHide()}
            >
              <CloseIcon />
            </CloseButton>
            <DwebIFrame title={TITLE} src={SOLD_BY_NYKAA_FASHION} />
          </>
        )}
      </OverlaySheetContext.Consumer>
    </DwebOverlaySheet>
  );
};
export default memo(Modal);
